import React from 'react';
import {
  Button,
  Form,
  FormField,
  FormFieldLabel,
  Input,
  Modal,
  RadioButton,
  Table
} from '@vwfs-bronson/bronson-react'
import './style.css';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import {
  fetchCustomerDataByIdentifier,
  selectCustomer,
  setSearchTerm,
  resetSearchResult
} from '../../redux/slices/customer-slice';
import { Navigate } from 'react-router-dom';
import CustomerDataInterface from "../../models/customer-data.interface";
import { formatter } from '../../utils/time-utils';
import { resetErrorDialog, selectNotificationStore } from '../../redux/slices/notification-slice';

export default function SearchCustomerForm() {
  const dispatch = useAppDispatch();
  const [identifierValue, setIdentifierValue] = React.useState('');
  const customer = useAppSelector(selectCustomer());
  const notification = useAppSelector(selectNotificationStore());

  const handleChange = (e: any) => {
    dispatch(resetErrorDialog());
    const searchTerm = e.target.value;
    setIdentifierValue(searchTerm)
    dispatch(setSearchTerm(searchTerm));
  }

  const handleChangeCustomer = (e: any) => {
    dispatch(resetErrorDialog());
    const searchTerm = e.target.value;
    setIdentifierValue(searchTerm)
    dispatch(setSearchTerm(searchTerm));
    dispatch(fetchCustomerDataByIdentifier(true));
  }

  const navigateToDetails = (e: any) => {
    e.preventDefault()
    dispatch(fetchCustomerDataByIdentifier(true))
  };

  const handleCloseCustomerSelectDialog = () => {
    dispatch(resetSearchResult());
  };

  function renderCustomerToSelect(customer: CustomerDataInterface) {
    return (
      <Table.Tr key={customer.id} data-testid={`customerToSelectTableRow_${customer.id}`}>
        <Table.Td>
          <RadioButton
            testId={`selectRadio_${customer.id}`}
            key={customer.id}
            name='selectedCustomer'
            checked={identifierValue === customer.id}
            value={customer.id}
            onChange={handleChangeCustomer}>
          </RadioButton>
        </Table.Td>
        <Table.Td>{`${customer.firstName} ${customer.lastName}`}</Table.Td>
        <Table.Td>{customer.driverId}</Table.Td>
        <Table.Td>{customer.accountStatus}</Table.Td>
        <Table.Td>{customer.idpHint}</Table.Td>
        <Table.Td>{formatter.format(new Date(customer.updatedAt))}</Table.Td>
      </Table.Tr>
    );
  }

  return (
    <Form floatingLabel testId="searchForm" onSubmit={navigateToDetails}>
      <p>Search for Customer</p>
      <FormField
        labelForId="test-form-input"
        labelText="Customer information"
        type="input"
        testId='testInputText'
      >
        <Input
          addonIcon="semantic-search"
          value={identifierValue}
          id="test-email-input"
          testId='testInputField'
          placeholder="Email, Customer ID or Driver ID"
          noBackground
          onChange={handleChange}
        />
      </FormField>
      <FormField
        style={{ paddingTop: '7px' }}
        type="input"
      >
        <Button
          onClick={navigateToDetails}
          key="applyFilters"
          testId='testApplyFiltersBtn'
        >
          Search
        </Button>
      </FormField >
      {notification?.errorDialog?.code === 'MISSING_CUSTOMER_SEARCH_FIELD' && <FormFieldLabel testId="noCustomerForEmailFoundLabel" className='Error'>Please enter customer Email or ID.</FormFieldLabel>}

      {notification?.errorDialog?.code === 'EMAIL_NOT_FOUND' && <FormFieldLabel testId="noCustomerForEmailFoundLabel" className='Error'>Customer not found with this Email.</FormFieldLabel>}
      {notification?.errorDialog?.code === 'ID_NOT_FOUND' && <FormFieldLabel testId="noCustomerForIdFoundLabel" className='Error'>Customer not found with this ID.</FormFieldLabel>}
      {notification?.errorDialog?.code === 'DRIVER_ID_NOT_FOUND' && <FormFieldLabel testId="noCustomerForDriverIdFoundLabel" className='Error'>Customer not found with this Driver ID.</FormFieldLabel>}
      {notification?.errorDialog?.code === 'FORBIDDEN_CUSTOMER' && (
        <FormFieldLabel testId="forbiddenLabel" className='Error'>
          Access forbidden.
        </FormFieldLabel>
      )}
      {customer.customer?.id && (customer.search.type === 'ID' || customer.search.type === 'EMAIL' || customer.search.type === 'DRIVER') && <Navigate to={`/customers/${customer.id}`} replace={true} />}

      <Modal
        large={true}
        shown={customer.search?.result !== undefined}
        onClose={handleCloseCustomerSelectDialog}
        title='Select a customer'
        status='warning'
        testId='selectCustomerModal'
      >
        <p>Found several customers with this email, select one to continue.</p>
        <Table colored={true} testId='customerToSelectTable'>
          <Table.Thead testId='customerToSelectTableHead'>
            <Table.Tr>
              <Table.Th></Table.Th>
              <Table.Th>Name</Table.Th>
              <Table.Th>Driver ID</Table.Th>
              <Table.Th>Status</Table.Th>
              <Table.Th>IdpHint</Table.Th>
              <Table.Th>Last Update</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>{customer.search?.result?.map(entry => renderCustomerToSelect(entry))}</Table.Tbody>
        </Table>

      </Modal>
    </Form>

  )
}
